import moment from 'moment';
import { Card, Row, Col } from 'react-bootstrap';
import { useEffect, useRef, useState } from "react";
import loader from "../assets/images/loader.gif";
import "./Quote.scss"
import HelperService from '../utility/HelperService';
import WebService from '../utility/WebService';
import { Button } from "../Button/Button";
import Loader from '../Loader/Loader';
import Modal from 'react-bootstrap/Modal';
import { Label } from '../Label/Label';
import { PlusSquare } from "react-bootstrap-icons";
import { toast } from 'react-toastify';
import QuoteApproval from './QuoteApproval';

interface propData {
    data: any;
    companyCode: number;
    techNum: string;
    onApproveSuccess: any;
}

const QuoteQuote = (props: propData) => {
     const [show, setShow] = useState(false);
     const [isLoading, setLoading] = useState(false);
     const [isQuoteSigned, setIsQuoteSigned] = useState(false);
     const openModal = () => setShow(true);
    const handleClose = (status?: boolean) => {
        setShow(false);

        if (status === true) {
            props.onApproveSuccess?.();  // reload quote info
        }
    };

    const handleApprovalClose = (status?: boolean) => {
        setShow(false);
        if (status === true) {
            setIsQuoteSigned(true);  // hide Approve button
            props.onApproveSuccess?.(); 
           // toast.success("Quote approved successfully!");
        }
    };


 useEffect(() => {
       setIsQuoteSigned(props?.data?.quoteSigned=="Y"? true:false)
    }, [props?.data?.quoteSigned])

    return (
        <>
         <Loader show={isLoading} />
          <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton  className="py-2 px-3" >
            <Modal.Title className="mb-0">  {/* fs-6 = smaller font size */}
                Quote Approval
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <QuoteApproval data={props?.data} companyCode={props?.companyCode} techNum={props?.techNum} onClose={handleApprovalClose} />
            </Modal.Body>
            </Modal>
            <div>
                <Card className="card-style form-style p-4" style={{ marginBottom: 10 }}>
                    <Row>
                        <Col>
                            <p className="mb-0 font-w-medium font-14">Quote Name</p>
                            <p className="font-14 mb-0">{props?.data?.quoteName ? props?.data?.quoteName : '-'}</p>
                        </Col>
                        <Col>
                            <p className="mb-0 font-w-medium font-14">Quote Description</p>
                              <p className="font-14 mb-0">{props?.data?.quoteDescription ? props?.data?.quoteDescription : '-'}</p>
                        </Col>
                    </Row>
                </Card>
            </div>
             <div>
                <Card className="card-style form-style p-4" >
                     <Row>
                        <Col>
                            <p className="mb-0 font-w-medium font-14">Quote #</p>
                            <p className="font-14 mb-0">{props?.data?.quoteNum ? props?.data?.quoteNum : '-'}</p>
                        </Col>
                        <Col>
                            <p className="mb-0 font-w-medium font-14">Quote Date</p>
                            <p className="font-14 mb-0">{props?.data?.quoteDate ? moment(props?.data?.quoteDate).format('MM/DD/YY') : '-'}</p>
                        </Col>
                        <Col>
                            <p className="mb-0 font-w-medium font-14">Amount</p>
                            <p className="font-14 mb-0">{props?.data?.quoteAmount ? "$" + HelperService.getCurrencyFormatter(props?.data?.quoteAmount) : '-'}</p>
                        </Col>
                        <Col>
                            { !isQuoteSigned && !props?.data?.allowToPickMultipleOptions &&
                                <Button 
                                label='Approve' 
                                size='medium'
                                onClick={openModal}
                                />
                            }
                        </Col>
                    </Row>
                </Card>
            </div>

        </>
    )
}

export default QuoteQuote;